export default __webpack_public_path__ + "locales/ru/ChangePhoneDialog.json?hash=5d460cba25a0f22c275e4dd0d88f1f0a";